import { DeviceInfo } from '../helpers/DeviceInfo';
import { SensorDetectionResult } from '../helpers/SensorsInfo';
import { FlowStatus } from './FlowStatus';

export interface EctStore {
  flowStatus: FlowStatus;
  initialized: boolean;
  environment: string;
  debug: boolean;
  requestId: string;
  redirectId: string;
  token: string;
  cameraIds: string[];
  cameraId: string;
  phoneNumber: string;
  apiBaseUrl: string;
  redirectBaseUrl: string;
  device: DeviceInfo;
  sensors: SensorDetectionResult;
  langIso: string;
  logSteps: boolean;
  idModelsPath: string;
  faceModelsPath: string;
  citizenship: string;
  idDocument: string;
  showCitizenshipSelector: boolean;
  scrollMode: boolean;
  analytics: boolean;
  videoRecording: boolean;
  glareTreshold: number;
  blurTreshold: number;
  idType: string;
  hasTilt: boolean;
  manualCaptureTimeout: number;
  manualCaptureEnabled: boolean;
  detectedCountryCode: string;
}
